import { formatPercentChange } from '@utils';

const PercentageColumn = ({ value }) => {
  const sign = value ? Math.sign(value) : null;
  const formatedValue = formatPercentChange(value);
  const symbol = sign ? (sign === 1 ? 'keyboard_arrow_up' : 'keyboard_arrow_down') : null;
  const color = sign ? (sign === 1 ? 'positive-percentage' : 'negative-percentage') : 'text-black';

  return (
    <td className={`${color}`}>
      {symbol && <i className="material-icons">{symbol}</i>}
      {formatedValue}
    </td>
  );
};

export default PercentageColumn;
